module.exports = __webpack_public_path__ + "assets/i18n/ach.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ach.json
// module id = 1211
// module chunks = 0